export default {
    contract: {
        header: "instruction.defaultHeader",
        body: "instruction.contract.body",
        dismiss: false
    },
    contractList: {
        header: "instruction.contractList.header",
        body: "instruction.contractList.body",
        dismiss: false
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/instruction/state.js